import { API_URL } from '../../../app-config/constants';
import type { ObjectiveCoachSuggestion } from '../../../types/ObjectiveCoachSuggestion';
import { get } from '../request';

interface Response {
    id: string;
    suggestion: ObjectiveCoachSuggestion;
}

getObjectiveCoachSuggestion.operation = 'READ';
export function getObjectiveCoachSuggestion(id: string): Promise<Response> {
    return get(`${API_URL}/objective-coach/${id}`);
}
